import styled from 'styled-components';
import { shade } from 'polished';

export const Conteiner = styled.div`
  p {
    font-size: 13px;
  }
`;
